
import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';

const CompanyPage: React.FC = () => {
  const historyData = [
    {
      year: '2024',
      month: '07',
      event: '전문건설업허가(지반조성·포장공사업-토공사)'
    },
    {
      year: '2022',
      month: '10',
      event: 'POSCO-내해수강건재 개발 및 실용화-MOU 체결'
    },
    {
      year: '2022',
      month: '01',
      event: '전문건설업허가 업종진환(지반조성·포장공사업 - 보링·그라우팅·파일공사)'
    },
    {
      year: '2021',
      month: '08',
      event: '건설기술용역업 등록(설계·사업관리)(경기1-2-948호)'
    },
    {
      year: '2021',
      month: '03',
      event: '한국지반신소재학회 기술상 수상'
    },
    {
      year: '2020',
      month: '09',
      event: '한국지반공학회 기술상 수상'
    },
    {
      year: '2019',
      month: '07',
      event: '전문건설업허가 취득(비계·구조물해체공사업)(의왕2019-06-01)'
    },
    {
      year: '2009',
      month: '09',
      event: '연구개발서비스업신고-공학 및 기술연구개발업(연구개발업)'
    },
    {
      year: '2009',
      month: '02',
      event: '국토교통부 신기술(제568호) 지정'
    },
    {
      year: '2008',
      month: '06',
      event: '소프트웨어사업자 신고(B20-196886)'
    },
    {
      year: '2005',
      month: '12',
      event: '부설연구소 전문연구요원 지정업체신청'
    },
    {
      year: '2004',
      month: '04',
      event: '지반조사업 개발 및 제작 인프라구축'
    },
    {
      year: '2003',
      month: '05',
      event: '기업부설연구소 설립(20031541호)'
    },
    {
      year: '2002',
      month: '02',
      event: '엔지니어링활동주체 신고-건설부문 토질 및 기초분야(10-1268호)'
    },
    {
      year: '2001',
      month: '03',
      event: '(주)지구환경전문가그룹 설립'
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section 
          className="relative py-32 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/3fb9fc015eb10373f5f4f80eddb077c5.jpg')`
          }}
        >
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto text-center text-white">
              <h1 className="text-6xl font-bold mb-6">
                지구환경전문가그룹
              </h1>
              <p className="text-2xl mb-8 leading-relaxed">
                20여 년간 축적된 전문성과 혁신 기술로<br />
                지반 조사 및 건설 모니터링 분야를 선도하는 기업
              </p>
              <div className="w-32 h-1 bg-blue-400 mx-auto"></div>
            </div>
          </div>
        </section>

        {/* Company Overview */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-6">
            <div className="max-w-6xl mx-auto">
              <div className="grid lg:grid-cols-2 gap-16 items-center">
                <div>
                  <h2 className="text-4xl font-bold text-gray-800 mb-8">
                    회사 개요
                  </h2>
                  <div className="space-y-6 text-lg text-gray-600 leading-relaxed">
                    <p>
                      (주)지구환경전문가그룹은 2001년 설립 이래 지반조사, 건설 모니터링, 
                      구조물 해체 등 건설 분야의 전문 기술 서비스를 제공하는 기업입니다.
                    </p>
                    <p>
                      국토교통부 신기술 지정, 다양한 전문 면허 보유, 그리고 지속적인 
                      연구개발을 통해 업계 최고 수준의 기술력을 인정받고 있습니다.
                    </p>
                    <p>
                      특히 지반 조사 및 모니터링 분야에서 축적된 노하우와 최신 기술을 
                      바탕으로 고객에게 최적의 솔루션을 제공하고 있습니다.
                    </p>
                  </div>
                </div>
                <div className="relative">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Modern%20construction%20monitoring%20equipment%20and%20ground%20investigation%20tools%2C%20professional%20engineering%20workspace%20with%20technical%20instruments%2C%20clean%20and%20organized%20laboratory%20environment&width=600&height=500&seq=company-overview&orientation=landscape"
                    alt="회사 개요"
                    className="rounded-xl shadow-lg w-full h-auto object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Business Areas */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-6">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-gray-800 mb-6">
                  주요 사업 분야
                </h2>
                <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
              </div>
              
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                    <i className="ri-hammer-line text-2xl text-blue-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4">지반조성·포장공사</h3>
                  <p className="text-gray-600 leading-relaxed">
                    전문건설업 면허를 바탕으로 한 체계적인 지반조성 및 포장공사 서비스
                  </p>
                </div>
                
                <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                    <i className="ri-search-line text-2xl text-green-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4">지반조사업</h3>
                  <p className="text-gray-600 leading-relaxed">
                    첨단 장비와 전문 인력을 활용한 정밀 지반조사 및 분석 서비스
                  </p>
                </div>
                
                <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-6">
                    <i className="ri-building-line text-2xl text-purple-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4">구조물해체공사</h3>
                  <p className="text-gray-600 leading-relaxed">
                    안전하고 효율적인 구조물 해체 및 철거 전문 서비스
                  </p>
                </div>
                
                <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                  <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-6">
                    <i className="ri-settings-line text-2xl text-orange-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4">엔지니어링 서비스</h3>
                  <p className="text-gray-600 leading-relaxed">
                    건설부문 토질 및 기초분야 전문 엔지니어링 컨설팅
                  </p>
                </div>
                
                <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                  <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
                    <i className="ri-computer-line text-2xl text-red-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4">소프트웨어 개발</h3>
                  <p className="text-gray-600 leading-relaxed">
                    건설 및 지반 분야 전문 소프트웨어 개발 및 공급
                  </p>
                </div>
                
                <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                    <i className="ri-flask-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4">연구개발</h3>
                  <p className="text-gray-600 leading-relaxed">
                    부설연구소 운영을 통한 지속적인 기술 혁신 및 개발
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Company History */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-6">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-gray-800 mb-6">
                  회사 연혁
                </h2>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                  2001년 설립 이래 20여 년간 지반 및 건설 분야에서 쌓아온 전문성과 성과
                </p>
                <div className="w-24 h-1 bg-blue-600 mx-auto mt-6"></div>
              </div>
              
              <div className="relative">
                <div className="absolute left-1/2 transform -translate-x-1/2 w-1 bg-blue-200 h-full"></div>
                
                {historyData.map((item, index) => (
                  <div key={index} className={`relative flex items-center mb-8 ${index % 2 === 0 ? 'justify-start' : 'justify-end'}`}>
                    <div className={`w-1/2 ${index % 2 === 0 ? 'pr-8' : 'pl-8'}`}>
                      <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100 hover:shadow-xl transition-shadow">
                        <div className="flex items-center mb-3">
                          <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
                            <span className="text-white font-bold text-sm">{item.year.slice(-2)}</span>
                          </div>
                          <div className="ml-3">
                            <span className="text-lg font-bold text-gray-800">{item.year}</span>
                            <span className="text-blue-600 font-semibold ml-2">{item.month}월</span>
                          </div>
                        </div>
                        <p className="text-gray-700 leading-relaxed">{item.event}</p>
                      </div>
                    </div>
                    
                    <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-blue-600 rounded-full border-4 border-white shadow-lg"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Certifications & Awards */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-6">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-gray-800 mb-6">
                  인증 및 수상
                </h2>
                <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
              </div>
              
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                <div className="bg-white rounded-xl p-6 shadow-lg text-center hover:shadow-xl transition-shadow">
                  <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-award-line text-2xl text-yellow-600"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2">국토교통부 신기술</h3>
                  <p className="text-gray-600 text-sm">제568호 지정</p>
                </div>
                
                <div className="bg-white rounded-xl p-6 shadow-lg text-center hover:shadow-xl transition-shadow">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-trophy-line text-2xl text-blue-600"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2">한국지반공학회</h3>
                  <p className="text-gray-600 text-sm">기술상 수상</p>
                </div>
                
                <div className="bg-white rounded-xl p-6 shadow-lg text-center hover:shadow-xl transition-shadow">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-medal-line text-2xl text-green-600"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2">한국지반신소재학회</h3>
                  <p className="text-gray-600 text-sm">기술상 수상</p>
                </div>
                
                <div className="bg-white rounded-xl p-6 shadow-lg text-center hover:shadow-xl transition-shadow">
                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-file-text-line text-2xl text-purple-600"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2">다수 전문면허</h3>
                  <p className="text-gray-600 text-sm">건설업 관련 인증</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Vision */}
        <section className="py-20 bg-blue-600">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto text-center text-white">
              <h2 className="text-4xl font-bold mb-8">
                미래 비전
              </h2>
              <p className="text-xl leading-relaxed mb-8">
                지구환경전문가그룹은 축적된 전문성과 지속적인 기술 혁신을 바탕으로<br />
                건설 및 지반 분야의 선도 기업으로 성장해 나가겠습니다.
              </p>
              <p className="text-lg opacity-90">
                고객의 신뢰를 바탕으로 더욱 안전하고 효율적인 건설 환경을 만들어가겠습니다.
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default CompanyPage;
